import { render } from "./BillShow.vue?vue&type=template&id=39e8788f"
import script from "./BillShow.vue?vue&type=script&lang=js"
export * from "./BillShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__